import React, {forwardRef} from 'react';
import BrandingStore from "../../../../../../common/services/config/brandingStore";

import {ChartRenderProps} from "./chartRenderProps";

import {
    Chart,
    ChartCategoryAxis,
    ChartCategoryAxisItem,
    ChartLegend, ChartSeries, ChartSeriesItem, ChartSeriesItemTooltip, ChartSeriesLabels,
    ChartTooltip,
    ChartValueAxis, ChartValueAxisItem
} from "@progress/kendo-react-charts";

import './chartRender.scss';

const ChartRender: React.FC<ChartRenderProps> = forwardRef(({handleSeriesClick, series, setup, categories, valueAxis}, ref: any) => {
    return (
        <Chart onSeriesClick={handleSeriesClick} seriesColors={BrandingStore.series_colors}
               className='chart-render-wrapper' ref={ref}>
            {series[0] && series[0].tooltip?.visible &&
                <ChartTooltip render={series[0].tooltip.callbackTemplate}/>}
            {series[0] && <ChartLegend position={setup?.legend} visible={series[0].legend?.visible}/>}

            {categories && (
                <ChartCategoryAxis>
                    {valueAxis.length === 1 &&
                        <ChartCategoryAxisItem name={'series-axes'} visible={false}
                                               categories={categories}/>}
                    <ChartCategoryAxisItem
                        majorGridLines={{visible: false}}
                        name={'category'}
                        visible={true}
                        axisCrossingValue={valueAxis.length === 1 ? -100000000000000 : [-100000000000000, 100000000000000]}
                        categories={categories}
                        labels={{rotation: 'auto'}}
                    />
                </ChartCategoryAxis>
            )}
            <ChartValueAxis>
                {valueAxis.map((item, idx) => (
                    <ChartValueAxisItem
                        key={idx}
                        name={item.name}
                        axisCrossingValue={valueAxis.length > 1 ? -100000000000 : [0, -100000000000000]}
                        labels={item.labels}
                        title={item.title}
                    />
                ))}
            </ChartValueAxis>

            <ChartSeries>
                {series.map((item, idx) => {
                    return item.stack ? (
                        <ChartSeriesItem
                            key={idx}
                            type={item.type}
                            field={'amount'}
                            //@ts-ignore
                            stack={{group: item.stack}}
                            data={item.data}
                            color={item.color}
                            name={item.name}
                            opacity={item.opacity}
                            markers={item.markers}
                            axis={item.axis}>
                            <ChartTooltip render={item.tooltip.callbackTemplate}/>
                            {item.labels.visible ? (
                                <ChartSeriesLabels visible={item.labels.visible}
                                                   position={item.labels.position}
                                                   content={item.labels.callbackTemplate}/>
                            ) : null}
                        </ChartSeriesItem>
                    ) : (
                        <ChartSeriesItem
                            key={idx}
                            type={item.type}
                            field={'amount'}
                            data={item.data}
                            color={item.color}
                            name={item.name}
                            opacity={item.opacity}
                            markers={item.markers}
                            axis={item.axis}>
                            <ChartSeriesItemTooltip render={item.tooltip.callbackTemplate}/>
                            {item.labels.visible ? (
                                <ChartSeriesLabels visible={item.labels.visible}
                                                   position={item.labels.position}
                                                   content={item.labels.callbackTemplate}/>
                            ) : null}
                        </ChartSeriesItem>
                    );
                })}
            </ChartSeries>
        </Chart>
    );
});

export default ChartRender;